var exports = {
  "M": "xfb577c5e--5db3a5--page",
};

module.exports = exports;
